// src/App.js
import React from "react";
import Choice from "./Choice";

function Home() {
  return (
    <div className="home">
      <Choice />
    </div>
  );
}

export default Home;
